import React from "react";
import { Link } from "react-router-dom";
import "../css/faqs.scss";

const questions = [
  { q: "Can I place an order on this website?", a: <>Not yet. Uightparcel is currently a preview catalogue. Adding items creates a browser-only selection; it does not reserve stock or submit an order.</> },
  { q: "Will the website ask for my card details?", a: <>No. Online payment is disabled, and the site does not request or store card numbers, expiry dates or security codes. Please do not send payment credentials by email.</> },
  { q: "Are the product images photographs of stock?", a: <>No. The current product images are original AI-generated visual representations based on the listed names, materials and features. They should not be treated as an exact representation of production colour, fit, texture or finish.</> },
  { q: "How can I ask about availability?", a: <>Email <a href="mailto:track@uightparcel.shop?subject=Catalogue%20availability">track@uightparcel.shop</a> with the product name, preferred size and colour. An enquiry does not create an order.</> },
  { q: "What does the site save in my browser?", a: <>Your product selection and cookie-notice choice may be stored locally in your browser. We do not currently use advertising or analytics cookies. See the <Link to="/cookies">Cookie Notice</Link>.</> },
  { q: "How will delivery and returns work?", a: <>Final shipping destinations, charges and return terms will be published before ordering opens. The current <Link to="/shipping">delivery</Link> and <Link to="/returns">returns</Link> pages explain the preview status.</> },
  { q: "How do I report content that affects my rights?", a: <>Follow the steps in our <Link to="/intellectual-property">IP &amp; Takedown Policy</Link>. We will review a sufficiently detailed notice and can restrict disputed material while it is assessed.</> },
  { q: "How do I request help using the site?", a: <>Email us with the page URL and a description of the issue. Accessibility information is available in our <Link to="/accessibility">Accessibility Statement</Link>.</> },
];

function Faqs() {
  return (
    <main className="faqs-page">
      <div className="faqs-intro">
        <p className="faqs-kicker">HELP</p>
        <h1>Frequently asked questions.</h1>
        <p>Short answers about the catalogue, privacy, payment status and rights.</p>
      </div>
      <div className="faqs-list">
        {questions.map((item, index) => (
          <details key={item.q} open={index === 0}>
            <summary><span>{String(index + 1).padStart(2, "0")}</span>{item.q}</summary>
            <div className="faq-answer">{item.a}</div>
          </details>
        ))}
      </div>
    </main>
  );
}

export default Faqs;
